import { mapState } from 'vuex'
import { getShortId } from '@/utils/format-strings'
import copyTextMixin from '@/components/mixins/copy-text-mixin'

export default {
  name: 'MarkerGroupOrders',
  /**   * 
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
   mixins: [copyTextMixin],
  props: {
    orders: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState({
      paymentTypes: state => state.sharedData.paymentTypes
    })
  },

  methods: {
    getShortId
  }
}
